const types = (value) => Array.isArray(value) ? value : [value];
export const schemaTypes = (schema) => !schema || typeof schema !== "object" ? [] : Array.isArray(schema)
  ? schema.flatMap(schemaTypes) : [...types(schema["@type"]).filter(Boolean), ...(Array.isArray(schema["@graph"]) ? schema["@graph"] : []).flatMap(schemaTypes)];

export function sanitizePageSchema(schema, site) {
  if (!schema || typeof schema !== "object") return null;
  if (Array.isArray(schema)) return schema.map((s) => sanitizePageSchema(s, site)).filter(Boolean);
  const kind = types(schema["@type"]);
  if (kind.some((type) => ["LocalBusiness", "ProfessionalService", "Review", "AggregateRating", "SearchAction"].includes(type))) return null;
  const clean = {};
  for (const [key, value] of Object.entries(schema)) {
    if (["aggregateRating", "review", "reviewRating", "reviewCount"].includes(key)) continue;
    if (key === "@graph") { clean[key] = (Array.isArray(value) ? value : []).map((s) => sanitizePageSchema(s, site)).filter(Boolean); continue; }
    if (["publisher", "provider", "seller"].includes(key) && value?.name === "I.T. Help of SWFL") { clean[key] = { "@id": `${site}/#business` }; continue; }
    clean[key] = value;
  }
  if (kind.some((type) => ["BlogPosting", "NewsArticle", "Article"].includes(type))) {
    clean["@type"] = "BlogPosting";
    const url = clean.mainEntityOfPage?.["@id"] || clean.url;
    if (url) clean["@id"] = `${url}#article`;
    clean.publisher = { "@id": `${site}/#business` };
  }
  return clean;
}

// Draft pages: layouts published for owner review; indexed once the content is supplied.
export const DRAFT_ROUTES = ["/about/jason", "/services/managed-it"];

export function routeRobots(path, search = "") {
  return DRAFT_ROUTES.includes(path) || /^\/(staff|book|urgent)(\/|$)/.test(path) || /^\/app\/(account|fix|request-tech|book|feedback|request)(\/|$)/.test(path)
    || /^\/shop\/(cart|quote|order|compare)(\/|$)/.test(path) || ["/directory", "/directory-links", "/terms"].includes(path)
    || /(^|[?&])build(=|&|$)/.test(search) ? "noindex,follow" : "index,follow";
}